import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initTranslations } from '@app/translations';
import initializeSentry from '@app/utils/initializeSentry';
import App from './App';
import createBorrowerRouter from './createBorrowerRouter';
import createDevRouter from './createDevRouter';
import createInvestorRouter from './createInvestorRouter';
initializeSentry();
initTranslations();
export const mountWithRouter = (el, router) => {
    const root = createRoot(el);
    root.render(<StrictMode>
            <App router={router}/>
        </StrictMode>);
};
export const mountBorrower = (el, { basename } = {}) => {
    const router = createBorrowerRouter({
        basename,
    });
    mountWithRouter(el, router);
};
export const mountInvestor = (el, { basename } = {}) => {
    const router = createInvestorRouter({
        basename,
    });
    mountWithRouter(el, router);
};
export const mount = (el, { basename, isStandalone } = {}) => {
    const router = createDevRouter({
        basename,
        isStandalone,
    });
    mountWithRouter(el, router);
};
